// Orderbook Aggregator endpoints
export const EXCHANGES = '/exchanges';
export const EXCHANGES_STATUS = '/exchanges/status';
export const ORDER_BOOKS = '/orderbooks';

// Crypto State Manager endpoints
export const CRYPTOS = '/cryptos';
export const READ_CRYPTOS = '/read-cryptos';
export const MODIFIED_CRYPTOS = '/modified-cryptos';

// Profits WebSocket endpoints
export const NOTIFICATIONS = '/notifications';
export const LOGIN = '/auth/login';
export const REFRESH = '/auth/refresh';

// Calculator endpoints
export const CALCULATOR_STATS = '/arbitrage/cache/stats';

// Connector health endpoints
export const CONNECTOR_HEALTH = '/exchanges/connectors/health';

// Health query keys (unique keys for react-query, not URL paths)
export const AGGREGATOR_HEALTH = 'aggregator-health';
export const PROFITS_WS_HEALTH = 'profits-ws-health';
export const CRYPTO_STATE_HEALTH = 'crypto-state-health';
export const CALCULATOR_HEALTH = 'calculator-health';

// Prediction health query keys
export const PREDICTION_MANAGER_HEALTH = 'prediction-manager-health';
export const PREDICTION_CALCULATOR_HEALTH = 'prediction-calculator-health';
export const PREDICTION_WS_HEALTH = 'prediction-ws-health';

// Aliases for backwards compatibility
export const CRYPTOS_READ = READ_CRYPTOS;
export const CRYPTOS_MODIFIED = MODIFIED_CRYPTOS;
export const TICKERS = '/tickers'; // Legacy - unused
